import React from 'react'
import { Typography } from '@jisr-hr/ds'
import PropTypes from 'prop-types'
import { Flex, Spacer, Button } from '@jisr-hr/design-system'
import { ReactComponent as EditIcon } from '@jisr-hr/design-system/dist/assets/icons/System/Edit.svg'
import { ReactComponent as DeleteIcon } from '@jisr-hr/design-system/dist/assets/icons/System/Delete.svg'
import { format } from 'utils/date'
import Styles from './style.module.css'
import Attachment from '../Attachment'

const ExpenseClaimItem = ({ item, onEditClick, onDeleteClick }) => {
  const attachment = item?.ecr_attachments?.length || item?.ecr_attachments_attributes

  return (
    <div className={Styles.itemContainer}>
      <Flex justifyBetween>
        <Flex itemsCenter>
          <Typography
            text={item?.name}
            variant="interface/strong/sm"
          />
          {item?.ecr_attachments ? null : (
            <>
              <Spacer width={8} />
              <Button
                size="small"
                variant="secondary"
                className={Styles.editDeleteButtons}
                onClick={onEditClick}
                icon={<EditIcon className={Styles.editDeleteIcons} />}
              />
            </>
          )}
          {item?.ecr_attachments ? null : (
            <Button
              size="small"
              variant="secondary"
              className={Styles.editDeleteButtons}
              onClick={onDeleteClick}
              icon={<DeleteIcon className={Styles.editDeleteIcons} />}
            />
          )}
        </Flex>
        <Typography
          text={`${item?.amount} SAR`}
          variant="interface/strong/sm"
          data-private
        />
      </Flex>
      {item?.date ? (
        <>
          <Typography
            text={format(item.date, 'EEEE, d MMM')}
            variant="body-new/regular"
            style={{ color: 'var(--color-base-colors-grey-600)' }}
            data-private
          />
          <Spacer height={16} />
        </>
      ) : null}
      {item?.description ? (
        <Typography
          text={item.description}
          variant="body-new/regular"
          style={{ color: 'var(--color-base-colors-grey-600)' }}
          data-private
        />
      ) : null}
      {attachment ? (
        <>
          <Spacer height={16} />
          <Flex
            flexCol
            style={{ gap: '16px' }}
          >
            <Attachment
              url={
                item?.ecr_attachments
                  ? item?.ecr_attachments[0]?.attachment_url
                  : item?.ecr_attachments_attributes?.attachment
              }
              name={
                item?.ecr_attachments
                  ? item?.ecr_attachments[0]?.attachment_file_name
                  : item?.ecr_attachments_attributes?.attachment_file_name
              }
              size={
                item?.ecr_attachments
                  ? item?.ecr_attachments[0]?.attachment_file_size
                  : item?.ecr_attachments_attributes?.attachment_file_size
              }
              withBox
            />
          </Flex>
        </>
      ) : null}
    </div>
  )
}

ExpenseClaimItem.defaultProps = {
  onEditClick: () => {},
  onDeleteClick: () => {},
}

ExpenseClaimItem.propTypes = {
  item: PropTypes.shape(),
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
}

export default ExpenseClaimItem
